




export default {
    components: {},
    name: 'index',
    head() {
        // 优化seo：动态设置title，keywords 和 description
        return {
            title: 'partner',
            meta: [
                {
                    name: "keywords",
                    content: "xppen-xfans-partner",
                },
                {
                    name: 'description', content: 'official information'
                },
            ],
        };
    },
    data() {
        return {

        };
    },



    methods: {


    }

}
